import * as yup from "yup";
import { ContentBlockData, ContentBlockSchema } from "./";

export interface ContentTextData extends ContentBlockData {
    body: string;
}

export const ContentTextSchema = yup.object().shape({
    body: yup.string().nullable(true).label("Body"),
}).concat(ContentBlockSchema);



// WEBPACK FOOTER //
// ./src/forms/adminPage/ContentText.ts